import {articleSearchItemTemplate} from './resourceTemplates/articleSearchItemTemplate.js';
import {courseSearchItemTemplate} from './resourceTemplates/courseSearchItemTemplate.js';
import {faqSectionSearchItemTemplate} from './resourceTemplates/faqSectionSearchItemTemplate.js';
import {localGroupSearchItemTemplate} from './resourceTemplates/localGroupSearchItemTemplate.js';
import {lessonSearchItemTemplate} from './resourceTemplates/lessonSearchItemTemplate.js';
import {masterclassSearchItemTemplate} from './resourceTemplates/masterclassSearchItemTemplate.js';
import {tagSearchItemTemplate} from './resourceTemplates/tagSearchItemTemplate.js';

import {getModelTypeByItem} from '../../../pages/search/helpers/getModelTypeByItem.js';

export const searchItemTemplate = (item, context) => {
    const modelType = getModelTypeByItem(item);

    switch (modelType) {
        case 'article':
            return articleSearchItemTemplate(item, context);
        case 'course':
            return courseSearchItemTemplate(item, context);
        case 'faq_section':
            return faqSectionSearchItemTemplate(item, context);
        case 'lesson':
            return lessonSearchItemTemplate(item, context);
        case 'local_group':
            return localGroupSearchItemTemplate(item, context);
        case 'masterclass':
            return masterclassSearchItemTemplate(item, context);
        case 'tag':
            return tagSearchItemTemplate(item, context);
        default:
            throw new Error(`No template found for '${modelType}'`);
    }
};
